import { put, takeLatest } from 'redux-saga/effects';
import { PAYMENT_REQUEST_API_ACTION } from '~redux/reducers/paymentRequestApi';
import { IntentState } from '~redux/reducers/intent';
import { PaymentRequestButtonElementOptions } from '~components/types';

const buildSupportedPaymentMethodData = () => {
  // Example supported payment methods:
  return [
    {
      supportedMethods: 'basic-card',
      data: {
        supportedNetworks: [
          'amex',
          'cartebancaire',
          'diners',
          'discover',
          'jcb',
          'mir',
          'unionpay',
          'visa',
          'mastercard',
        ],
        supportedTypes: ['debit', 'credit'],
      },
    },
  ];
};

const buildShoppingCartDetails = (
  intent: IntentState,
  shippingOptions: PaymentRequestButtonElementOptions['shippingOptions'],
) => {
  const { order, currency = '', id, amount } = intent || ({} as IntentState);
  const { products } = order || {};
  return {
    id,
    displayItems: (products || []).map(({ name, code, sku, quantity, unit_price }) => ({
      label: `${name} - ${code} - ${quantity} * ${sku}`,
      amount: { currency, value: `${quantity * unit_price}` },
    })),
    total: {
      label: 'Total Amount',
      amount: { currency, value: `${amount}` },
    },
    shippingOptions,
  };
};

type DataProps = Pick<
  PaymentRequestButtonElementOptions,
  'requestPayerName' | 'requestPayerEmail' | 'requestPayerPhone' | 'requestShipping' | 'shippingOptions'
>;

interface PayloadProps extends DataProps {
  intent: IntentState;
}

export function* getPaymentRequestApi(data: { type: string; payload: PayloadProps }) {
  let request = null;
  if (window.PaymentRequest) {
    try {
      request = new PaymentRequest(
        buildSupportedPaymentMethodData(),
        buildShoppingCartDetails(data.payload.intent, data.payload?.shippingOptions),
        {
          requestPayerEmail: data.payload?.requestShipping ?? true,
          requestShipping: data.payload?.requestShipping ?? false,
          requestPayerName: data.payload?.requestShipping ?? false,
          requestPayerPhone: data.payload?.requestShipping ?? false,
        },
      );
      const canMakeAFastPayment = yield request.canMakePayment();
      // @ts-ignore
      const hasEnrolledInstruments = yield request.hasEnrolledInstrument();
      yield put({
        type: PAYMENT_REQUEST_API_ACTION,
        payload: {
          support: canMakeAFastPayment && hasEnrolledInstruments,
          request,
        },
      });
    } catch (error) {
      yield put({
        type: PAYMENT_REQUEST_API_ACTION,
        payload: {
          support: false,
          request,
        },
      });
    }
  }
}

export function* watchGetPaymentRequestApiAsync() {
  yield takeLatest('AWX_GET_PAYMENT_REQUEST_API_ASYNC', getPaymentRequestApi);
}
